if (!customElements.get("expanded-gallery-modal")) {
  customElements.define(
    "expanded-gallery-modal",
    class ExpandedGalleryModal extends ModalDialog {
      constructor() {
        super();
        this.mediaItems = [...this.querySelectorAll(".product-expanded-gallery-media")];
        this.thumbButtons = [...this.querySelectorAll(".product-expanded-gallery-thumb, .cc-lightbox__thumb-btn")];
        this.mainArea = this.querySelector(".product-expanded-gallery-main");
        this.sidebar = this.querySelector(".product-expanded-gallery-sidebar");

        this.addEventListener("click", (event) => {
          if (event.target === this) {
            this.hide();
          }
        });

        this.thumbButtons.forEach((thumb) => {
          thumb.addEventListener("click", () => {
            this.setActiveMedia(thumb.dataset.mediaId);
          });
        });

        if (this.mainArea && this.sidebar) {
          this.mainArea.addEventListener(
            "wheel",
            (event) => {
              event.preventDefault();
              this.sidebar.scrollTop += event.deltaY;
            },
            { passive: false },
          );
        }

        // REDESIGN LIGHTBOX ARROWS & CLOSE BUTTON
        this.prevButton = this.querySelector("[data-lightbox-prev]");
        this.nextButton = this.querySelector("[data-lightbox-next]");
        this.closeButton = this.querySelector("[data-lightbox-close]");

        if (this.prevButton) {
          this.prevButton.addEventListener("click", (e) => {
            e.stopPropagation();
            this.navigate(-1);
          });
        }
        if (this.nextButton) {
          this.nextButton.addEventListener("click", (e) => {
            e.stopPropagation();
            this.navigate(1);
          });
        }
        if (this.closeButton) {
          this.closeButton.style.cursor = "pointer";
          this.closeButton.addEventListener("click", (e) => {
            e.stopPropagation();
            this.hide();
          });
        }
      }

      show(opener) {
        super.show(opener);
        const requestedMediaId = opener?.dataset?.mediaId;
        const fallbackMediaId = this.thumbButtons[0]?.dataset.mediaId;
        this.setActiveMedia(requestedMediaId || fallbackMediaId);

        // Bind keyboard navigation
        this._onKeyDown = (e) => {
          if (e.key === "Escape") this.hide();
          if (e.key === "ArrowLeft") this.navigate(-1);
          if (e.key === "ArrowRight") this.navigate(1);
        };
        window.addEventListener("keydown", this._onKeyDown);
      }

      hide() {
        super.hide();
        if (this._onKeyDown) {
          window.removeEventListener("keydown", this._onKeyDown);
        }
      }

      navigate(direction) {
        if (!this.mediaItems.length) return;
        const activeIndex = this.mediaItems.findIndex(item => item.classList.contains("is-active"));
        if (activeIndex === -1) return;
        const newIndex = (activeIndex + direction + this.mediaItems.length) % this.mediaItems.length;
        const targetMediaId = this.mediaItems[newIndex].dataset.mediaId;
        this.setActiveMedia(targetMediaId);
      }

      setActiveMedia(mediaId) {
        if (!mediaId) {
          return;
        }

        let hasMatch = false;
        let matchedIndex = 0;

        this.mediaItems.forEach((item, idx) => {
          const isActive = item.dataset.mediaId === mediaId.toString();
          item.classList.toggle("is-active", isActive);
          if (isActive) {
            hasMatch = true;
            matchedIndex = idx;
          }
        });

        this.thumbButtons.forEach((thumb) => {
          const isActive = thumb.dataset.mediaId === mediaId.toString();
          thumb.classList.toggle("is-active", isActive);
          if (isActive) {
            thumb.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
          }
        });

        // Update counter and sub-label if present
        const counterEl = this.querySelector("[data-lightbox-counter]");
        if (counterEl) {
          const pad = (n) => String(n).padStart(2, "0");
          counterEl.textContent = `${pad(matchedIndex + 1)} / ${pad(this.mediaItems.length)}`;
        }

        const labelEl = this.querySelector("[data-lightbox-label]");
        if (labelEl && this.mediaItems[matchedIndex]) {
          const altText = this.mediaItems[matchedIndex].querySelector("img")?.getAttribute("alt") || "";
          labelEl.textContent = altText;
        }

        if (!hasMatch && this.thumbButtons.length) {
          const firstMediaId = this.thumbButtons[0].dataset.mediaId;
          this.setActiveMedia(firstMediaId);
        }
      }
    },
  );
}
